import { useSelectedFilterStore } from "../store/filtersv2";
import { ArrayFilter, Filters } from "../types/filters";
import { useFeatureServices } from "../use-feature-services";
import { getSingleSelectedDealer } from "./get-single-selected-dealer";
import { createConfiguration, createConstantData, createPartner } from "./get-tracking-event-data";

const handleClick = (label: string, type : keyof Filters) => {
    const { tracking } = useFeatureServices();
    const { selected, selectFilter } = useSelectedFilterStore();
    const selection: string[] = selected[type] as ArrayFilter || [];

    const partner = getSingleSelectedDealer();

    const handleClickForTracking = (e: React.SyntheticEvent<HTMLInputElement>) => {
        const { name, value } = e.currentTarget;
        const updatedSelection = selection?.includes(value)
          ? selection.filter((item) => item !== value)
          : [...selection, value];
          selectFilter(name as keyof Filters, updatedSelection);

        if (e.currentTarget.checked) {
          tracking.track('VWBasic_FilterSelect_Click', {
            ...createConstantData(),
            configuration: createConfiguration(),
            partner: createPartner(partner),
            link: {
              url: window.location.href,
              name: (e.currentTarget.offsetParent as HTMLLabelElement).innerText
            },
            filter: {
              type: 'multi_value',
              name: label,
              values: updatedSelection,
            }
          });
        }
    };

    return handleClickForTracking;
}

export default handleClick;
